import { FC } from 'react';

type Props = {
	className?: string;
};

const CreditCardIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M2 10.0004C2 7.17026 2 5.7552 2.84227 4.81047C2.97699 4.65936 3.12547 4.51962 3.28602 4.39283C4.2898 3.6001 5.79329 3.6001 8.80028 3.6001H11.2004C14.2074 3.6001 15.7109 3.6001 16.7146 4.39283C16.8752 4.51962 17.0237 4.65936 17.1584 4.81047C18.0007 5.7552 18.0006 7.17026 18.0006 10.0004C18.0006 12.8305 18.0007 14.2455 17.1584 15.1902C17.0237 15.3414 16.8752 15.4811 16.7146 15.6079C15.7109 16.4006 14.2074 16.4006 11.2004 16.4006H8.80028C5.79329 16.4006 4.2898 16.4006 3.28602 15.6079C3.12547 15.4811 2.97699 15.3414 2.84227 15.1902C2 14.2455 2 12.8305 2 10.0004Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M8.39844 13.2002H9.59849'
				stroke='inherit'
				strokeWidth='1.25'
				strokeMiterlimit='10'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M12 13.2002H14.8001'
				stroke='inherit'
				strokeWidth='1.25'
				strokeMiterlimit='10'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M2 7.6001H18.0006'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default CreditCardIcon;
